module.exports = __webpack_public_path__ + "media/KikiM.66ceed7c.mp3";